import { takeLatest, put, call } from 'redux-saga/effects';
import swal from 'sweetalert';

import { history } from '@commons';

import { deleteOutrasSaidaAnimal } from '../service';
import {
  DELETE_OUTRAS_SAIDA_ANIMAL,
  DELETE_OUTRAS_SAIDA_ANIMAL_PENDING,
  DELETE_OUTRAS_SAIDA_ANIMAL_SUCCESS,
  DELETE_OUTRAS_SAIDA_ANIMAL_FAILURE,
} from '../actionTypes';

import { AlertError, AlertWarning } from '@components/common/AlertToast'

function* sagaDeleteOutrasSaidaAnimal(action) {
  yield put({ type: DELETE_OUTRAS_SAIDA_ANIMAL_PENDING, id: action.id })

  try {
    const a = yield call(deleteOutrasSaidaAnimal, action.id);

    if (a.status !== 204) {
      throw new Error('API delete request failed');
    }
    yield put({ type: DELETE_OUTRAS_SAIDA_ANIMAL_SUCCESS, id: action.id });

    swal({
      title: 'Excluído!',
      icon: 'success',
      buttons: {
        cancel: false,
        confirm: {
          text: 'OK',
          value: true,
          visible: true,
          className: 'btn-primary',
          closeModal: true
        }
      }
    }).then(() => {
      history.go(0)
    });

  } catch (error) {
    yield put({ type: DELETE_OUTRAS_SAIDA_ANIMAL_FAILURE });

    if (error.response.status === 403) {
      AlertWarning('Saída não pode ser excluída');
    } else {
      AlertError('Falha ao excluir a Saída! Tente novamente...');
    }
  }
}

export default function* watchDeleteOutrasSaidaAnimal() {
  yield takeLatest(DELETE_OUTRAS_SAIDA_ANIMAL, sagaDeleteOutrasSaidaAnimal)
}
